<template>
  <div class="container">
    <div class="d-flex flex-column">
      <div class="text-h3 text-uppercase text-center">Información</div>
      <UserInfo></UserInfo>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import UserInfo from '@/components/normal/UserInfo'

export default {
  components: {
    UserInfo
  },
  head() {
    return {
      title: {
        inner: 'Información de usuario'
      },
      meta: [
        {
          name: 'description',
          content: `${this.appTitle} UserInfo page`,
          id: 'UserInfo'
        }
      ]
    }
  },
  computed: mapState('app', ['appTitle'])
}
</script>

<style lang="scss" scoped>
@import '@/theme/variables.scss';

.page-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 100%;

  .logo {
    max-width: 350px;
    height: auto;
  }

  .home-page-title {
    text-align: center;
  }

  .documentation-link {
    display: inline-block;
    font-size: 1.2rem;
    color: #fff;
    background-color: #5d6788;
    padding: 0.8rem 1.6rem;
    border-radius: 4px;
    transition: background-color 0.1s ease;
    box-sizing: border-box;
    text-decoration: none;
    width: fit-content;
    font-weight: 500;
  }

  .product-list-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    width: 100%;

    // border: 5px solid red; // TODO: Eliminar codigo
  }
}
</style>
